import React from 'react';
import { TableCell } from './TableCells';

export const CrmRow = ({ layout, item, height, handleOnClick, disabled = false  }) => {
    return (
        <div className={`d-flex flex-row card justify-content-left align-items-center w-100 ${disabled ? 'bg-light text-secondary border-light' : ''}`}  style={{ height: height }}>
            {layout.map((field) => {
                return (
                    <TableCell
                        key={`tablecell-${field.textContent}`}
                        item={item}
                        height={height}
                        disabled={field.disabledField}
                        type={field.type}
                        content={field.textValue}
                        link={field.linkValue}
                        width={field.width}
                        onClick={disabled ? null : handleOnClick}
                    />
                );
            })}
        </div>
    );
};
